<template>
    <div class="center" id="center_container">
        <div>
            <label for="scaleRange" class="d-block text-center">
                Scale: {{(scale).toFixed(2)}}
            </label>
            <input type="range" id="scaleRange"
                   :min="0.01" :max="2"
                   :step="0.05"
                   :value="scale"
                   @input="updateScale(countScale($event.target.value))">
        </div>
        <div class="scrollable-content">
            <div class="centered" id="layout_centered_container"
                 ref="layout_centered_container"
                 :style="{transform: parsedScale, position: 'relative', width: 'auto', height: '%'}">
                <rendered-template></rendered-template>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import RenderedTemplate from '../../../Rendered/RenderedTemplate.vue';
import DragAndDropMixin from '../../../../../../mixins/DragAndDropMixin.vue';
import { mapMutations, mapGetters } from 'vuex';

export default {
    name: 'WorkspaceAreaCenter',
    data () {
        return {
            evListener: {}
        };
    },
    mixins: [DragAndDropMixin],
    components: {
        RenderedTemplate
    },
    computed: {
        ...mapGetters({
            scale : 'getScale',
            parsedScale: 'getParsedScale',
            uidKey: 'getUid',
            editedElementId: 'getEditedElementId'
        })
    },
    methods: {
        ...mapMutations(['updateScale']),
        countScale (newScale) {
            if(newScale > 0.1) {
                return +newScale;
            }
            return this.scale;
        }
    },
    mounted () {
        this.evListener = (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            if(ev.deltaY < 0 && this.scale <= 1.95) {
                this.updateScale(this.scale + 0.05);
            } else if (this.scale >= 0.1) {
                this.updateScale(this.scale - 0.05);
        
            }
        };
        this.$refs.layout_centered_container.addEventListener('wheel', this.evListener );
    },
    beforeDestroy () {
        this.$refs.layout_centered_container.removeEventListener('wheel', this.evListener );
    }
};
</script>

<style lang="scss" scoped>
    .center {
        overflow: hidden;
        .scrollable-content {
            overflow-y: auto;
            height: 100%;
            /*width: calc(100% + 40px);*/
            padding-right: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: aliceblue;
            
            .centered {
                /*display: flex;*/
                /*justify-content: center;*/
                /*align-items: center;*/
                width: auto;
                height: auto;
                border: 1px solid black;
                *:hover {
                    border: 2px solid black;
                }
            }
        }
    }
  
    #scaleRange {
        width: 100%;
    }

</style>
